import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["icon"]
  static values = { copy: String }

  copy() {
    navigator.clipboard.writeText(this.copyValue).then(() => {
      this.iconTarget.classList.replace("fa-copy", "fa-check")
      this.iconTarget.classList.replace("fa-regular", "fa-solid")
      this.iconTarget.classList.add("text-success")

      setTimeout(() => {
        this.iconTarget.classList.replace("fa-check", "fa-copy")
        this.iconTarget.classList.replace("fa-solid", "fa-regular")
        this.iconTarget.classList.remove("text-success")
      }, 1500)
    })
  }
}
